export default __webpack_public_path__ + "static/media/knowpoint.43a91a21.jpg";